import type { ReactNode } from 'react';

export const symbol_diamond_shine: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M440-121 162-395q-17-17-18-39.5t14-40.5l144-176q8-10.62 20-16.31 12-5.69 26-5.69h267q14 0 26 5.69T661-651l145 176q15 18 14 41t-18 40L524-121q-17.31 17-42.16 17Q457-104 440-121ZM122-793q9-9 22-9t22 9l28 29q8 9 8.5 21t-8.5 21q-8 8-20.5 8.5T152-721l-29-29q-9-9-9.5-21.5T122-793Zm381.5-78.38q8.5 8.63 8.5 21.38v41q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-41q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62Zm335.37 78.59q9.13 9.22 8.63 21.5Q847-759 838-750l-29 29q-9 8-21 8t-21-8.84q-9-8.84-9-21t9-21.16l29-29q9.07-9 21.53-9 12.47 0 21.34 9.21ZM236-406l246 242 246-242H236Zm-8-60h508L615-613H349L228-466Z"
		/>
	</svg>
);
